
define('text!modules/campaign/templates/duplicateStrategiesErrorGrid.html',[],function () { return '<div class="item-wrapper">\n  <div class="item">\n    <div class="column errored-strategy-name">\n      <div class="item-c">{{from_strategy}}</div>\n    </div>\n    <div class="column errored-reason">\n      <div class="item-c">{{error}}</div>\n    </div>\n  </div>\n</div>\n';});

